import { render, staticRenderFns } from "./cmpskeletondashboard.vue?vue&type=template&id=18abc341&"
import script from "./cmpskeletondashboard.vue?vue&type=script&lang=js&"
export * from "./cmpskeletondashboard.vue?vue&type=script&lang=js&"
import style0 from "./cmpskeletondashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports